import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/chat'

export default {
    getChatBox() {
        return axios.get(`${V1}${RESOURCE_NAME}/mybox`)
    },

    createChatRoom(body) {
        return axios.post(`${V1}${RESOURCE_NAME}/ChatGroup`, body);
    },

    deleteChatRoom(roomId) {
        return axios.delete(`${V1}${RESOURCE_NAME}/group/delete/${roomId}`);
    },
}
